
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feedback",
      function () {
        return require("private-next-pages/feedback/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feedback"])
      });
    }
  